var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXdcFeatureIcon3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53077 31.824C1.17 31.0116 1.17 28.981 2.53077 28.1686L14.9581 20.7503C16.319 19.9379 18.0199 20.9533 18.0199 22.5782V37.4148C18.0199 39.0394 16.319 40.0548 14.9581 39.2424L2.53077 31.824Z",
    fill: "#5235E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.501961,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1981 28.0363H37.4437C38.6248 28.0363 39.5822 28.9941 39.5822 30.1746C39.5822 31.3558 38.6248 32.3132 37.4437 32.3132H18.1981V28.0363Z",
    fill: "#5235E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.011 9.6358C40.3718 10.4482 40.3718 12.4791 39.011 13.2915L26.5836 20.7094C25.2229 21.5218 23.5219 20.5064 23.5219 18.882V4.04533C23.5219 2.42092 25.2229 1.40548 26.5836 2.21747L39.011 9.6358Z",
    fill: "#5235E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.501961,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3436 9.50378H4.09812C2.91712 9.50378 1.95972 10.4608 1.95972 11.642C1.95972 12.8229 2.91712 13.7807 4.09812 13.7807H23.3436V9.50378Z",
    fill: "#5235E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdcFeatureIcon3);
export default __webpack_public_path__ + "static/media/xdc-feature-icon-3.7c549262dc6a3d3659f6d1236156c4b6.svg";
export { ForwardRef as ReactComponent };